import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { Icon } from '@material-ui/core';
import { TransferenciaContext } from 'app/main/transferencia/TransferenciaContext';
import { cancelarAlert } from 'app/services/alerts';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useEffect } from 'react';
import { TransferenciaModais } from '../TransferenciaModais';
import { TransferenciaForm } from './content';
import TransferenciaSchema from './schemas/TransferenciaSchema';

const TransferenciaCadastroModal = ({ onSubmit }) => {
  const [modal, setModal] = useContext(TransferenciaContext).modal;
  const [transferencia, setTransferencia] = useContext(TransferenciaContext).transferencia;

  const initialValues = {
    ...transferencia,
    id: transferencia?.id,
    contaOrigemId: transferencia?.contaOrigemId,
    contaDestinoId: transferencia?.contaDestinoId,
    valor: transferencia?.valor,
    data: transferencia?.data,
    descricao: transferencia?.descricao,
    edicao: transferencia?.edicao,
  };

  const onSubmitForm = async (values) => {
    const params = {};

    params.id = values?.id;
    params.empresaId = getEmpresaContexto();
    params.origemId = values?.contaOrigemId?.id;
    params.destinoId = values?.contaDestinoId?.id;
    params.valor = values?.valor;
    params.data = values?.data;
    params.descricao = values?.descricao;

    const response = await onSubmit(params);

    if (response) {
      close();
    }
  };

  const close = () => {
    setTransferencia({});
    formik.resetForm({});
    setModal('');
  };

  const handleCloseModal = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const formik = useFormik({
    validationSchema: TransferenciaSchema,
    initialValues,
    onSubmit: onSubmitForm,
    validateOnChange: true,
    validateOnBlur: true,
  });

  useEffect(() => {
    formik.resetForm(initialValues);
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferencia]);

  return (
    <>
      <SimpleDialog fullScreen open={modal === TransferenciaModais.cadastrarTransferencia} onClose={handleCloseModal}>
        <FormikProvider value={formik}>
          <FormDialogContent
            onSubmit={formik.handleSubmit}
            fullScreen
            header={{
              title: 'Cadastro de transferência',
              icon: <Icon>compare_arrows</Icon>,
              toolbar: (
                <>
                  <CancelButton title="cancelar" type="button" onClick={handleCloseModal}>
                    Cancelar
                  </CancelButton>
                  <SaveButton color="buttonSave" type="submit">
                    Salvar
                  </SaveButton>
                </>
              ),
            }}
            content={<TransferenciaForm />}
          />
        </FormikProvider>
      </SimpleDialog>
    </>
  );
};

export default TransferenciaCadastroModal;
